import { useState, useEffect, useContext } from "react";
import "../styles/globals.css";
import "../styles/pegment.css";
import Shell from "../components/layout/shell";
import { useRouter } from "next/router";
import Head from "next/head";
import {ThemeProvider} from 'next-themes';
import { LocaleProvider } from "../contexts/locale-context";
import BusinessContext from "../contexts/business-context";

function MyApp({ Component, pageProps }) {
  const [isMounted, setIsMounted] = useState(false);
  const {activeBusiness} = useContext(BusinessContext);
  const router = useRouter();

  useEffect(() => {
    if (router.isReady) {
      setIsMounted(true);
    }
  }, [router.isReady]);

  if (!isMounted) return null;

  const getLayout = Component.isUnprotected
    ? (page) => <ThemeProvider>
        <title>Workpeg</title>
      <div className="h-[100dvh] pb-[calc(100dvh-100vh)]">{page}</div></ThemeProvider>
    : (page) => <Shell>{page}</Shell>;

  return (
    <LocaleProvider>
      <Head>
        <link rel="manifest" href="/manifest.json" />
        <link rel="apple-touch-icon" href="/images/pwa-logo.svg"></link>
      </Head>
      {getLayout(<Component {...pageProps} />)}
    </LocaleProvider>
  );
}

export default MyApp;
